import apiService from '../apiService';

const LivestockRecordService = {
  listLivestockRecord: (params) => apiService.get('/livestock-records', params),
  getLivestockRecordByDetailMovementId: (id) => apiService.get(`/livestock-records/detail/${id}`),
  createLivestockRecord: (data) => apiService.post('/livestock-records', data),
  updateLivestockRecord: (id, data) => apiService.put(`/livestock-records/${id}`, data),
  deleteLivestockRecord: (id) => apiService.delete(`/livestock-records/${id}`),
};

export default LivestockRecordService;
